import { defineStore } from 'pinia'
import { ref } from 'vue'
import { normalizeLuckyDropItems } from '@/utils/reward-result'
import { ackLuckyDropRecords } from '@/api'

export const useLuckyDropStore = defineStore('luckyDrop', () => {
  const visible = ref(false)
  const items = ref([])
  const title = ref('成交礼遇')
  const pendingRecordIds = ref([])

  function present(payloadOrList) {
    const list = Array.isArray(payloadOrList) ? payloadOrList : [payloadOrList]
    const normalized = normalizeLuckyDropItems(list)
    if (!normalized.length) return false
    pendingRecordIds.value = list.map((x) => x.recordId).filter((id) => id != null)
    items.value = normalized
    visible.value = true
    return true
  }

  async function dismiss() {
    visible.value = false
    items.value = []
    const ids = [...pendingRecordIds.value]
    pendingRecordIds.value = []
    if (ids.length) {
      try {
        await ackLuckyDropRecords(ids)
      } catch (e) {
        /* ignore ack errors */
      }
    }
    uni.$emit('luckyDropDismissed')
  }

  return { visible, items, title, present, dismiss }
})
